<template>
  <v-app>
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-12">
          <div class="card">

            <v-container fluid>
                <v-card-title>
                  <v-spacer/>
                  {{ $route.meta.title }}
                  <v-spacer/>
                  <v-btn :loading="loading" @click="reload" color="primary" rounded
                         class="text-white">
                    <v-icon>mdi-refresh</v-icon>
                    به روزرسانی
                  </v-btn>

                </v-card-title>
                <v-divider/>


              <div class="row mb-1">
                <div class="col-md-3">
                  <select
                      @change="reloadTable1(tableProps)"
                      v-model="tableProps.importance"
                      class="form-control">
                    <option value>درجه اهمیت</option>
                    <option value='deposit'>معمولی</option>
                    <option value='withdraw'>مهم</option>
                    <option value='withdraw'>خیلی مهم</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <select
                      @change="reloadTable1(tableProps)"
                      v-model="tableProps.status"
                      class="form-control">
                    <option value>همه ی وضعیت ها</option>
                    <option value='open'>باز</option>
                    <option value='closed'>بسته شده</option>
                  </select>
                </div>
                <div class="col-md-3">

                  <select
                      @change="reloadTable1(tableProps)"
                      v-model="tableProps.service_id"
                      class="form-control">
                    <option value>همه ی سرویس ها</option>
                    <option value='1'>کورلند</option>
                    <option value='2'>پیامک لند</option>
                    <option value='3'>کیوآرلند</option>
                    <option value='4'>ربات لند</option>
                  </select>

                </div>

                <div class="col-md-3">

                  <select
                      @change="reloadTable1(tableProps)"
                      v-model="tableProps.department_id"
                      class="form-control">
                    <option value>همه ی دپارتمان ها</option>
                    <option value='1'>فنی</option>
                    <option value='2'>مالی</option>
                  </select>

                </div>




              </div>



                <div class="row">

                  <div class="col-md-12 p-5">


                    <data-table
                        :data="data"
                        :columns="columns"
                        class="p-2"
                        :debounce-delay="5000"
                        :translate="translate"
                        :per-page="[10, 25, 50, 100, 400]"
                        @on-table-props-changed="reloadTable"
                    >
                    </data-table>

                  </div>
                </div>

<!--              </v-card>-->

            </v-container>
          </div>
        </div>
      </div>

    </div>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialog"
    >

      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar
              color="primary"
              dark
          > <div class="text-h3 text-center">{{item.title}}</div></v-toolbar>
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                text
                color="pink"
                dark
                @click="dialog.value = false"
            >بستن</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

  </v-app>
</template>
<script >
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import interActionBtn from "@/view/pages/tickets/interActionBtn";
import userLinkBtn from "@/view/pages/admin/adminNotifications/userLinkBtn";

export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url:'ticket',
      columns:[



        {
          name: 'id',
          label: 'شناسه',
          orderable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          orderable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          orderable: true,
          transform: (value) => {
            return this.ticketStatus(value.data.status);
          }
        },
        {
          label: 'اهمیت',
          name: 'importance',
          orderable: true,
          transform: (value) => {
            return this.importanceStatus(value.data.importance);
          }
        },

        {
          label: 'کاربر',
          name: 'user',
          orderable: true,
          transform: (value) => {
            return value.data.user.name+' ' +value.data.user.lastName;
          }
        },




        {
          name: 'updated_at',
          label: 'آخرین به روزرسانی',
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.updated_at);
          }
        },
        {
          name: 'show',
          label: 'عملیات',
          component: Button,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'show',
                label: 'تغییر وضعیت',
                icon: 'pencil-alt',
                class:'btn-outline-info',
              },
              {
                name: 'edit',
                label: 'پاسخ تیکت',
                icon: 'comment',
                class:'btn-outline-success',
              }



            ]
          }
        },




        // {
        //   name: 'actions',
        //   label: 'بازخورد',
        //   component: interActionBtn,
        //   handler: this.actions,
        //   event: 'action',
        //   meta: {
        //
        //     permission_prefix: 'notification_',
        //     // buttons: [
        //     //   {
        //     //     name: 'show',
        //     //     label: 'نمایش',
        //     //     icon: 'eye',
        //     //     class:'btn-outline-info',
        //     //   }
        //     // ]
        //   }
        // }
      ],
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
        importance:'',
        service_id:'',
        status:'',
        department_id:'',
      },
    }
  },
  methods: {
    reloadTable(tableProps) {
      this.getNotifications(this.url, tableProps);
    },
    getNotifications(url= this.url, query= this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(response => {
          this.data = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
        });
    },
    reload() {
      this.getNotifications(this.url, this.tableProps);
    },

    reloadTable1(tableProps) {
      this.getNotifications(this.url, tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    show(data) {
      this.$router.push({name: 'adminTickets.edit', params: {id: data.id}});
    },
    edit(data) {
      this.$router.push({name: 'tickets.edit', params: {id: data.id}})
    },


    ticketStatus(data) {
      if (data === 'open') {
        return `<span class="badge-pill badge badge-success">باز</span>`;
      } else if (data === 'closed') {
        return `<span class="badge-pill badge badge-danger">بسته</span>`;
      }
    },

    importanceStatus(data) {
      if (data === 1) {
        return `<span class="badge-pill badge badge-danger">بسیار مهم</span>`;
      } else if (data === 2) {
        return `<span class="badge-pill badge badge-warning">مهم</span>`;
      } else if (data === 3) {
        return `<span class="badge-pill badge badge-light">معمولی</span>`;
      }
    },



    notifyStatus(data) {
      if (data.status === 'pending') {
        return 'در انتظار';
      } else if (data.status === 'sent') {
        return 'ارسال شده';
      } else if (data.status === 'denied') {
        return 'ارسال نشده';
      } else if (data.status === 'payed') {
        return 'پرداخت شده';
      } else if (data.status === 'approved') {
        return 'تایید شده';
      }
    }
  },
  created() {
    this.getNotifications(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);
  },
}
</script>